const CACHE_KEY = 'lumora_products_cache_v4';
const FRESH_TTL_MS = 60_000;
const STALE_TTL_MS = 5 * 60_000;

function parseCache(raw) {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (!parsed?.at || !Array.isArray(parsed.data)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function readProductCache({ allowStale = false } = {}) {
  try {
    const parsed = parseCache(localStorage.getItem(CACHE_KEY));
    if (!parsed) return null;

    const age = Date.now() - parsed.at;
    if (age <= FRESH_TTL_MS) return parsed.data;
    if (allowStale && age <= STALE_TTL_MS) return parsed.data;
    return null;
  } catch {
    return null;
  }
}

export function writeProductCache(data) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), data }));
    // Drop legacy caches that may contain outdated hardcoded prices.
    localStorage.removeItem('lumora_products_cache_v1');
    localStorage.removeItem('lumora_products_cache_v2');
    localStorage.removeItem('lumora_products_cache_v3');
  } catch {
    /* storage full or private mode */
  }
}

export function clearProductCache() {
  try {
    localStorage.removeItem(CACHE_KEY);
    localStorage.removeItem('lumora_products_cache_v1');
    localStorage.removeItem('lumora_products_cache_v2');
    localStorage.removeItem('lumora_products_cache_v3');
  } catch {
    /* ignore */
  }
}
